import { createI18n } from 'vue-i18n';
import fr from '@/locales/fr.json';

/* require.context ne fonctionne pas avec Jest => on met manuellement ci-dessous dans "messages"
function loadLocaleMessages(): LocaleMessages {
  const locales = require.context(
    '../locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages: LocaleMessages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
} */

export type Lang = 'en' | 'fr';

export function getAvailableLanguages(): string[] {
  return ['fr', 'en'];
}

export function getLanguageName(value): string {
  switch (value) {
    case 'fr':
      return 'français';
    case 'en':
      return 'anglais';
    default:
      return '';
  }
}

export function getAvailableLanguagesOptions(): Array<{
  name: string;
  value: string;
}> {
  return [
    { name: 'Français', value: 'fr' },
    { name: 'English', value: 'en' },
  ];
}

const i18n = createI18n({
  locale: import.meta.env.VITE_APP_I18N_LOCALE,
  fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE,
  legacy: false,
  messages: {
    fr,
  },
});

export async function loadLanguage(language: Lang): Promise<void> {
  if (!i18n.global.availableLocales.includes(language)) {
    const messages = await import(`@/locales/${language}.json`);
    i18n.global.setLocaleMessage(language, messages.default);
  }
  i18n.global.locale.value = language;
}

export default i18n;
